import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as contextVariableService from '../../data/services/contextVariableService';
import './ContextVariableSelector.css';

const ContextVariableSelector = ({ selectedIds = [], onSelectionChange }) => {
  const [contextVariables, setContextVariables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(new Set(selectedIds));

  useEffect(() => {
    loadContextVariables();
  }, []);

  useEffect(() => {
    setSelected(new Set(selectedIds));
  }, [selectedIds]);

  const loadContextVariables = async () => {
    try {
      setLoading(true);
      const variables = await contextVariableService.getAllContextVariables();
      setContextVariables(variables.map(v => v.toJSON()));
    } catch (error) {
      console.error('Error loading context variables:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (id) => {
    const newSelected = new Set(selected);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelected(newSelected);
    
    if (onSelectionChange) {
      onSelectionChange(Array.from(newSelected));
    }
  };

  if (loading) {
    return (
      <div className="context-variable-selector">
        <div className="loading">Loading context variables...</div>
      </div>
    );
  }

  return (
    <div className="context-variable-selector">
      <h3 className="selector-title">Context Variables</h3>
      <p className="selector-description">
        Select context variables to include when copying this prompt.
      </p>
      {contextVariables.length === 0 ? (
        <p className="context-variable-selector-empty">
          No context variables yet.{' '}
          <Link to="/context-variables" className="context-variable-selector-empty-link">
            Add them on the Context Variables page
          </Link>
          .
        </p>
      ) : (
        <div className="context-variable-checkboxes">
          {contextVariables.map((variable) => {
            const isSelected = selected.has(variable.id);
            const preview = (variable.context || '').length > 100
              ? (variable.context || '').substring(0, 100) + '...'
              : (variable.context || '');

            return (
              <label
                key={variable.id ?? `cv-${variable.title}-${variable.createdAt}`}
                className={`context-variable-checkbox ${isSelected ? 'selected' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleToggle(variable.id)}
                  disabled={variable.id == null}
                />
                <div className="checkbox-content">
                  <div className="checkbox-title-row">
                    <span className="checkbox-title">{variable.title}</span>
                    {variable.isGlobal && (
                      <span className="checkbox-global-badge">Global</span>
                    )}
                  </div>
                  <span className="checkbox-preview">{preview}</span>
                </div>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ContextVariableSelector;

